<template>
  <div class="relative h-full">
    <!-- 一级菜单选项 -->
    <div
      class="flex h-full text-[#666666] font-400 text-14px w-full overflow-x-auto flex-nowrap scrollbar"
      ref="nav"
    >
      <div
        v-for="(item, index) in navList"
        :key="index"
        class="h-full text-center  flex-shrink-0 flex items-center mx-5px"
      >
        <span
          @click="navbarClick(item)"
          class="relative"
          :title="item.name"
          :class="{
            active: currentNav === item.id,
          }"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'

const columnApi = new ColumApi()
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
    mode: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      subNavbarVisible: false, // 二级导航栏菜单box, 显示二级菜单的
      navbar: {},
      subNavbarChildren: [],
      subNavbar: {}, // 当前二级菜单子项
      columnData: [],
      currentNav: '',
      translateX: 0,
      navList: [],
    }
  },
  computed: {
    columnId() {
      return this.$route.query.columnId
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      async handler(val, oldVal) {
        if (!_.isEqual(val?.columnIds, oldVal?.columnIds)) {
          this.navList = await this.getNavList()
        }
      },
    },
    columnId: {
      immediate: true,
      handler(val) {
        this.currentNav = val
      },
    },
  },
  methods: {
    async getNavList() {
      if (this.columnData.length === 0) {
        await this.getColumnData()
      }
      if (!this.data?.columnIds) return []
      const list = []
      _.forEach(this.data.columnIds, (item) => {
        const column = _.find(this.columnData, { id: item })
        if (column) {
          list.push(column)
        }
      })
      return list
    },

    // 一级navbar-click
    navbarClick(navbar) {
      if (this.mode === 'update') return
      this.currentNav = navbar.id
      this.$router.push({
        path: '/portal/homepage',
        query: {
          columnId: navbar.id,
        },
      })
    },
    async getColumnData() {
      const [err, res] = await columnApi.tree(0, {
        isExistPage: true,
      })
      if (!err) {
        this.columnData = res
      }
    },
  },
}
</script>
<style scoped lang="scss">
.scrollbar {
  &::-webkit-scrollbar {
    width: 0px !important;
    display: none !important;
  }
}
.active {
  color: var(--portalPrimaryColor);
  &::before {
    content: '';
    position: absolute;
    // width: 40px;
    width: 100%;
    // transform: translate(50%, 0);
    height: 3px;
    background-color: var(--portalPrimaryColor);
    bottom: -7px;
  }
}
.sub-nav-item {
  &:hover {
    color: var(--portalPrimaryColor);
  }
}
</style>
